import VisualPlan from 'app/frontend/types/custom/VisualPlan'
import { RaidPlanOwner } from 'app/frontend/base/api/raid_plans'
import VisualPlanThumbnail from './VisualPlanThumbnail'
import useVisualPlanLiveSync from './visual_plans/hooks/useVisualPlanLiveSync'

type Props = {
  visual: VisualPlan
  owner: RaidPlanOwner
  className?: string
}

const LiveSyncedVisualPlanThumbnail = ({ visual, owner, className }: Props) => {
  useVisualPlanLiveSync({ owner, visualId: visual.id })
  return <VisualPlanThumbnail visual={visual} className={className} />
}

export default LiveSyncedVisualPlanThumbnail
